import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';

//Components

import SideNav from '@components/individualPortal/navigation/SideNavigation';
import NavBarContainer from '../common/NavBarContainer';
import TicketQuickActionBar from './ticketQuickActionBar';

//Configs

import { configs } from '@constants/configs/configs';
import {
    ticketManagementNavLinks,
    ticketManagementTicketDetailNavLinks,
} from '../individualPortal/navigation/configs/ticketManagementSideNavConfigs';

// Utils

import { environmentSelector } from '@selectors/commonSelectors';
import { getTicketData } from '@utils/localStorage/sendMessageLocalStorage';

const TicketMgmtContainer = props => {
    const {
        environment: { stateCode, ticketEnabled, user: { activeModuleName, role } = {} },
    } = props;
    const currentRoute = useLocation()?.pathname;

    const {
        routes: {
            TICKET_MGMT_EXCHANGE_ASSIGNEES,
            TICKET_MGMT_MANAGE_TAGS,
            TICKET_MGMT_MANAGE_CUSTOM_FIELDS,
            TICKET_MGMT_MANAGE_WORKGROUP,
            TICKET_MGMT_MANAGE_CANNED_RESPONSES,
            TICKET_MGMT_WORKGROUP_TAG_EDIT_REDIRECT,
        },
    } = configs;

    const checkForTicketDetailCookie = () => {
        const cookies = `; ${document.cookie}`;
        const parts = cookies.split('; showExtendedMenu=true');
        return parts.length > 1;
    };

    const TICKETDETAILPAGE = checkForTicketDetailCookie();

    const [sideNavData, setSideNavData] = useState({ ...getTicketData() });

    const headingRenderFunction = () => {
        if (TICKETDETAILPAGE) {
            return (
                <div className="tablet:grid-col-12 ticket-mgmt-qab">
                    <TicketQuickActionBar ticketData={sideNavData} handleChange={setSideNavData} />
                </div>
            );
        } else {
            let messageId;

            const appendix = currentRoute.split('/').pop();

            if (currentRoute.includes(TICKET_MGMT_WORKGROUP_TAG_EDIT_REDIRECT)) {
                messageId = 'ticket_management_header.manageworkgroup';
            } else {
                const routeToMessageIdMap = {
                    [TICKET_MGMT_EXCHANGE_ASSIGNEES]: `ticket_management_header.${appendix}`,
                    [TICKET_MGMT_MANAGE_TAGS]: `ticket_management_header.${appendix}`,
                    [TICKET_MGMT_MANAGE_CUSTOM_FIELDS]: `ticket_management_header.${appendix}`,
                    [TICKET_MGMT_MANAGE_WORKGROUP]: `ticket_management_header.${appendix}`,
                    [TICKET_MGMT_MANAGE_CANNED_RESPONSES]: 'ticket_management_header.manageCannedResponse',
                };

                messageId = routeToMessageIdMap[currentRoute] || 'ticket_management_header.default';
            }

            return (
                <div className="tablet:grid-col-9">
                    <h1 id="skip" className="ticket-mgmt-heading">
                        <FormattedMessage id={messageId} />
                    </h1>
                </div>
            );
        }
    };

    const sideNavRenderFunction = () => {
        if (TICKETDETAILPAGE) {
            return (
                <aside className="desktop:grid-col-3" id="ticket-detail-side-nav">
                    <SideNav
                        {...{ stateCode }}
                        navLinks={ticketManagementTicketDetailNavLinks}
                        visibilityParams={sideNavData}
                        outerClass={'ticket-nav'}
                    />
                </aside>
            );
        } else {
            return (
                <aside className="desktop:grid-col-3" id="side-nav">
                    <SideNav
                        {...{ stateCode }}
                        navLinks={ticketManagementNavLinks}
                        visibilityParams={{ ticketEnabled, role, activeModuleName }}
                    />
                </aside>
            );
        }
    };
    return (
        <main className="usa-layout-docs usa-section gi-main-section" id="ticketManagement">
            <div className="grid-container gi-grid-container">
                <div className="grid-row grid-gap gi-wrapper">
                    <div className="grid-col-12">
                        <div className="grid-row">
                            <NavBarContainer navBarClass="ticket-mgmt-top-nav grid-col-12" />
                        </div>
                        <div className="grid-row">{headingRenderFunction()}</div>
                    </div>
                    <Fragment>
                        {sideNavRenderFunction()}
                        <div className="desktop:grid-col-9" id="main-content">
                            <Outlet />
                        </div>
                    </Fragment>
                </div>
            </div>
        </main>
    );
};

const mapStateToProps = state => ({
    environment: environmentSelector(state),
});

export default connect(mapStateToProps)(TicketMgmtContainer);
